import { login, logout, getInfo, sendvcode, updatepwd, getvcodeimage, SwitchDepart, GetUserSelfInfo, UpdateUserSelfInfo, ChangeUserPwd, loginSms, resetPwd, codelogin, checkUser, resetPwdBySms, modifyPwd } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'
import store from '../../store'
const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    userId: '',
    roles: '',
    pwdErrorTime: 0,
    departId: '',
    voiceNotify: false,
    voiceNotifyFinishedReport: false,
    dict: { // 字典
      treatmentType: [], // 诊疗类型
      checkType: [], // 设备类型
      scanningtType: [], // 扫描类型
      nativePlace: [], // 籍贯
      patientSource: [], // 患者来源
      patinentType: [] // 患者类型
    },
    hospitals: '',
    currentUserRoleDepart: {
      roleName: ''
    },
    userInfo: ''
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      // console.log(avatar)
      state.avatar = avatar
    },
    SET_USERID: (state, datas) => {
      state.userId = datas
    },
    SET_DEPARTID: (state, datas) => {
      state.departId = datas
    },
    SET_VOICENOTIFY: (state, voiceNotify) => {
      state.voiceNotify = voiceNotify
    },
    SET_VOICENOTIFYFINISHEDREPORT: (state, voiceNotifyFinishedReport) => {
      state.voiceNotifyFinishedReport = voiceNotifyFinishedReport
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_HOSPITALS: (state, hospitals) => {
      state.hospitals = hospitals
    },
    GET_PATIENTTYPE: (state, patinentType) => { // 患者类型字典
      state.dict.patinentType = patinentType
    },
    GET_TREATMENTTYPE: (state, treatmentType) => { // 诊疗类别字典
      state.dict.treatmentType = treatmentType
    },
    GET_CHECKTYPE: (state, checkType) => { // 设备类型字典
      state.dict.checkType = checkType
    },
    GET_PATIENTSOURCE: (state, patientSource) => { // 患者来源字典
      state.dict.patientSource = patientSource
    },
    GET_SCANNINGTYPE: (state, scanningtType) => { // 扫描类型字典
      state.dict.scanningtType = scanningtType
    },
    GET_NATIVEPLACE: (state, nativePlace) => { // 籍贯字典(省)
      state.dict.nativePlace = nativePlace
    },
    SET_ROLEDEPART: (state, currentUserRoleDepart) => { // 医院列表
      state.currentUserRoleDepart = currentUserRoleDepart
    },
    SET_USERINFO: (state, data) => { //
      state.userInfo = data
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then((response) => {
          resolve(response)
          const data = response.data
          setToken(data.token)
          commit('SET_TOKEN', data.token)
        }).catch(error => {
          reject(error)
        })
      })
    },
    Codelogin({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        codelogin(userInfo).then((response) => {
          resolve(response)
          const data = response.data
          setToken(data.token)
          commit('SET_TOKEN', data.token)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo(state.token).then(response => {
          const data = response.data
          if (data.userInfo.currentUserRoleDepart) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', data.userInfo.currentUserRoleDepart.roleModule)
            commit('SET_DEPARTID', data.userInfo.currentUserRoleDepart.departId)
            commit('SET_VOICENOTIFY', data.userInfo.currentUserRoleDepart.voiceNotify)
            commit('SET_VOICENOTIFYFINISHEDREPORT', data.userInfo.currentUserRoleDepart.voiceNotifyFinishedReport)
            commit('SET_ROLEDEPART', data.userInfo.currentUserRoleDepart)
            commit('SET_HOSPITALS', data.userInfo.userDepartRoleList)
          } else {
            reject('getInfo: roles must be a non-null array !')
          }
          commit('SET_NAME', data.userInfo.userName)
          commit('SET_USERID', data.userInfo.userId)
          commit('SET_AVATAR', data.userInfo.avatar)
          for (var i = 0; i < data.dictInfoList.length; i++) {
            switch (data.dictInfoList[i].dictType) {
              case '患者类型':
                commit('GET_PATIENTTYPE', data.dictInfoList[i].dictList)
                break
              case '诊疗类别':
                commit('GET_TREATMENTTYPE', data.dictInfoList[i].dictList)
                break
              case '设备类型':
                commit('GET_CHECKTYPE', data.dictInfoList[i].dictList)
                break
              case '患者来源':
                commit('GET_PATIENTSOURCE', data.dictInfoList[i].dictList)
                break
              case '扫描类型':
                commit('GET_SCANNINGTYPE', data.dictInfoList[i].dictList)
                break
              case '籍贯':
                commit('GET_NATIVEPLACE', data.dictInfoList[i].dictList)
                break
            }
          }

          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 账号验证
    CheckUser({ commit }, data) {
      return new Promise((resolve, reject) => {
        checkUser(data).then((response) => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 重置密码
    ResetPwdBySms({ commit }, data) {
      return new Promise((resolve, reject) => {
        resetPwdBySms(data).then((response) => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_ROLES', [])
          store.dispatch('FedLogOut')
          resolve()
        }).catch(error => {
          store.dispatch('FedLogOut')
          reject(error)
        })
      })
    },
    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    },

    // 发送手机验证码
    SendVCode({ commit }, mobile) {
      mobile = mobile.trim()
      return new Promise((resolve, reject) => {
        sendvcode(mobile).then((response) => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 修改密码
    ResetPwd({ commit }, mobile) {
      return new Promise((resolve, reject) => {
        resetPwd(mobile).then((response) => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登录时修改密码
    ModifyPwd({ commit }, mobile) {
      return new Promise((resolve, reject) => {
        modifyPwd(mobile).then((response) => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登录发送手机验证码
    LoginSms({ commit }, mobile) {
      return new Promise((resolve, reject) => {
        loginSms(mobile).then((response) => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 重置密码
    ResetPassword({ commit }, updatePasswordInfo) {
      return new Promise((resolve, reject) => {
        updatepwd(updatePasswordInfo).then((response) => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取图片验证码
    GetVCodeImage({ commit }, username) {
      return new Promise((resolve, reject) => {
        getvcodeimage(username).then((response) => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 切换科室
    PostSwitchDepart({ commit }, departId) {
      return new Promise((resolve, reject) => {
        SwitchDepart(departId).then((response) => {
          resolve(response)
          this.$router.push({ path: '/dashboard' })
        }).catch(error => {
          reject(error)
        })
      })
    },

    getUserSelfInfo({ commit }) {
      return new Promise((resolve, reject) => {
        GetUserSelfInfo().then((response) => {
          const data = response.data
          commit('SET_USERINFO', data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    updateUserSelfInfo({ commit }, datas) {
      return new Promise((resolve, reject) => {
        UpdateUserSelfInfo(datas).then((response) => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    ChangeUserPwd({ commit }, datas) {
      return new Promise((resolve, reject) => {
        ChangeUserPwd(datas).then((response) => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 重置
    resetuser({ commit }) {
      commit('SET_ROLES', [])
      commit('SET_DEPARTID', '')
      commit('SET_HOSPITALS', '')
      commit('SET_NAME', '')
      commit('SET_USERID', '')
    }
  }
}

export default user
